import { SignUp } from "@clerk/react";
import { Zap } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function SignUpPage() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#F2F2F0] grain">
      <header className="brutal-border border-l-0 border-r-0 border-t-0 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-[#FF3311] brutal-border w-10 h-10 flex items-center justify-center">
              <Zap className="w-6 h-6 text-white" strokeWidth={3} />
            </div>
            <div className="font-display text-xl md:text-2xl uppercase leading-none">
              {t("app.name")}
            </div>
          </div>
          <LanguageSwitcher />
        </div>
      </header>
      <main className="max-w-xl mx-auto px-6 md:px-10 py-10 md:py-16 flex items-center justify-center">
        <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
      </main>
    </div>
  );
}
